import { AsyncStorage } from '@pletly/common';

const CALLBACK_URL_KEY = 'callback_url';

function getCallbackUrl() {
	return AsyncStorage.getString(CALLBACK_URL_KEY);
}

function setCallbackUrl(url: string | undefined) {
	if (!url) {
		return AsyncStorage.removeItem(CALLBACK_URL_KEY);
	}

	return AsyncStorage.setStorageItem(CALLBACK_URL_KEY, url);
}

export { setCallbackUrl, getCallbackUrl };
